import { SelectInput } from './select.mjs';
import FormanConfig from '../formanConfig.mjs';
import { registerCustomElement, composedInputBuilder, create } from '../utils.mjs';
import { I18n } from '../helpers/i18n.mjs';
import { DEFAULT_THEME } from '../helpers/color.mjs';

const config = FormanConfig.config.fields.connectedSystems;

export class ConnectedSystemInput extends SelectInput {
	get allowApiCall() {
		return true;
	}

	constructor() {
		super();
		this.panel = null;
	}

	get hasModeSwitch() {
		return false;
	}

	get stateDataProps() {
		return [];
	}

	extendInstructions(instructions) {
		instructions.options = instructions.options || {};

		instructions.options.label = instructions.options.label || config.api.list.label;
		instructions.options.value = instructions.options.value || config.api.list.value;
		instructions.options.wrapper = instructions.options.wrapper || config.api.list.wrapper;
		instructions.options.placeholder =
			instructions.options.placeholder || I18n.l('connectedSystems.chooseConnectedSystems');
		// add proper theme logic for connected-system input
		instructions.theme = DEFAULT_THEME;

		const storeQuery = new URLSearchParams();

		storeQuery.append('organizationId', this.form.meta.organizationId);
		instructions.options.store = `${config.api.list.path}?${storeQuery}`;

		return instructions;
	}

	_shouldLoadOnBuild(options, value) {
		return typeof value !== 'undefined' && value !== '';
	}

	async _build(instructions, value, metadata) {
		const picker = create('imt-picker');
		const connectedSystemName = instructions.type.split(':')[1];

		metadata.data = { connectedSystemName };
		metadata.build = Object.assign(metadata.build || {}, { picker });

		await super._build(instructions, value, metadata);

		// add proper icon logic for connected-system input
		this.append(
			composedInputBuilder({
				picker,
				config,
				name: 'http',
				theme: instructions.theme,
				buttons: [
					// {
					// 	label: I18n.l('common.edit'),
					// 	action: () => null,
					// 	collapsible: true,
					// },
				],
				readonly: this.readonly,
				image: instructions?.image,
			}),
		);
	}
}

registerCustomElement('imt-input-connectedsystem', ConnectedSystemInput);
